// src/extenders/header.js
var HeaderElemnent = class extends HTMLElement {
  constructor() {
    super();
    const navigationElement = this;
    const responsivePadding = () => {
      const navigationItems = navigationElement.querySelectorAll(".navigation-items");
      navigationItems.forEach((navigationItem) => {
        const ariaControls = navigationItem.getAttribute("aria-controls");
        const positionLeft = navigationItem.offsetLeft;
        const modal = document.querySelector(`div[aria-labelledby="${ariaControls}"]`);
        if (modal) {
          const divSublink = modal.querySelector(".div-sublinks");
          divSublink.style.paddingLeft = `${positionLeft}px`;
        }
      });
    };
    responsivePadding();
    window.addEventListener("resize", responsivePadding);
  }
};
if (customElements.get("navigation-header") === void 0) {
  customElements.define("navigation-header", HeaderElemnent);
}
